<template>
  <LazyHomeCommonLayout>
    <template #content>
      <LazyHomeSubPagesSupportPricing />
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import { useSeoMeta } from '~/composables/useSeoMeta'
import { useUserStore } from '~/store/user/userStore'
import { useUserService } from '~/composables/service/useUserService'

const { getCanonical, getHreflangLinks } = useSeoMeta()
const userStore = useUserStore()
const userService = useUserService()

onMounted(() => {
  if (userStore.isAuthResolved) {
    if (!userStore.isLogOut()) userService.setUser(false)
    return
  }
  const stop = watch(() => userStore.isAuthResolved, (resolved) => {
    if (resolved) {
      stop()
      if (!userStore.isLogOut()) userService.setUser(false)
    }
  })
})

useHead({
  title: 'Pricing | Codepresso',
  meta: [
    { name: 'description', content: 'Choose the plan that fits your needs. Compare Basic, Pro, and Enterprise plans for technical skill assessment.' },
    { name: 'title', content: 'Pricing | Codepresso' },
    { name: 'robots', content: 'index,follow' },
    { property: 'og:title', content: 'Pricing | Codepresso' },
    { property: 'og:description', content: 'Choose the plan that fits your needs. Compare Basic, Pro, and Enterprise plans for technical skill assessment.' },
  ],
  link: [...getHreflangLinks.value, { rel: 'canonical', href: getCanonical.value }],
})

definePageMeta({
  alias: ['/en/home/pricing', '/ja/home/pricing', '/ko/home/pricing', '/vi/home/pricing'],
})
</script>

<style>
@import "~/assets/scss/main_style.scss";
</style>
